// extracted by mini-css-extract-plugin
export default {"description":"project_description__4FyYe","container":"project_container__jdGDZ","project":"project_project__V+nqp","item":"project_item__BFHyk","pill":"project_pill__jq3H-"};